const webDevSteps = [
  {
    number: "01",
    title: "Anforderungsanalyse & Planung",
    description:
      "Wir arbeiten eng mit Ihnen zusammen, um Ihre Projektziele, Zielgruppen und technischen Anforderungen genau zu verstehen. Auf Basis dieser Informationen erstellen wir einen detaillierten Projektplan mit realistischen Zeitrahmen und klar definierten Meilensteinen.",
  },
  {
    number: "02",
    title: "Design & Prototyping",
    description:
      "Unsere Designer entwickeln aussagekräftige Wireframes und interaktive Prototypen, die die geplante Benutzerführung und visuelle Identität Ihrer Website widerspiegeln. So haben Sie frühzeitig die Möglichkeit, Feedback zu geben, und wir können das Design optimal anpassen.",
  },
  {
    number: "03",
    title: "Entwicklung",
    description:
      "Mit modernsten Technologien und Frameworks setzen unsere Entwickler Ihre Website um, wobei wir großen Wert auf sauberen Code, Skalierbarkeit und hohe Leistung legen. Ihre Website wird nicht nur optisch überzeugen, sondern auch technisch auf dem neuesten Stand sein.",
  },
  {
    number: "04",
    title: "Testen & Qualitätssicherung",
    description:
      "In dieser Phase führen wir umfangreiche Tests durch, um die Funktionalität, Benutzerfreundlichkeit und Kompatibilität Ihrer Website auf verschiedenen Geräten und Browsern zu überprüfen. Unser Ziel ist es, eine fehlerfreie und optimale Nutzererfahrung zu garantieren.",
  },
  {
    number: "05",
    title: "Bereitstellung & Support",
    description:
      "Nach erfolgreicher Entwicklung und intensiver Testphase stellen wir Ihre Website in der Produktionsumgebung bereit und begleiten den Launch. Darüber hinaus bieten wir langfristigen Support und regelmäßige Updates, um den anhaltenden Erfolg Ihrer Online-Präsenz zu sichern.",
  },
];

export default webDevSteps;
